var map = {
	"./Armario.png": 592,
	"./Asistencia en carretera.png": 1516,
	"./Batería.png": 593,
	"./Baño.png": 278,
	"./Calor.png": 1517,
	"./Casa color 1.png": 1518,
	"./Chapa y pintura.png": 1519,
	"./Climatizacion.png": 594,
	"./Coche Climatización.png": 1520,
	"./Coche Desguace.png": 1521,
	"./Coche Limpieza.png": 1522,
	"./Coche Luna.png": 1523,
	"./Coche accesorios.png": 595,
	"./Coche color.png": 596,
	"./Coche duda.png": 597,
	"./Coche eléctrico.png": 1524,
	"./Cocina.png": 598,
	"./Escaleras.png": 1525,
	"./ITV.png": 1526,
	"./Neumáticos.png": 1527,
	"./Panel solar.png": 599,
	"./Pared.png": 1528,
	"./Persianas.png": 600,
	"./Puerta de paso.png": 601,
	"./Revisiones.png": 1529,
	"./Suelo.png": 370,
	"./Taladro.png": 602,
	"./Tejado.png": 603,
	"./albanil.png": 604,
	"./antenista.png": 605,
	"./carp.madera.png": 1530,
	"./carp.metal.png": 606,
	"./cerrajero.png": 607,
	"./construccion.png": 608,
	"./cristalero.png": 371,
	"./customizacion.png": 372,
	"./electricista.png": 609,
	"./electrodomesticos.png": 373,
	"./fontanero.png": 610,
	"./jardinero.png": 611,
	"./limpieza.png": 612,
	"./manitas.png": 613,
	"./mudanzas.png": 1531,
	"./pintor.png": 614,
	"./piscina.png": 374,
	"./reformas.png": 375,
	"./toldos-y-persianas.png": 615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 369;